import React from 'react';
import PropTypes from 'prop-types';

import { PaginationTable, MoneyCell, StatusCell, DateCell } from 'common/components';

const PartnerAccountInfoTable = ({ data, getList, loading, history, location, params }) => {
  /* eslint-disable */
  const columns = [
    {
      Header: 'accountId',
      Cell: ({
        row: {
          original: { account },
        },
      }) => <p className="account">{account}</p>,
      isPreviewCell: true,
    },
    {
      Header: 'justAmount',
      Cell: ({
        row: {
          original: { calculatedAmount },
        },
      }) => <MoneyCell value={calculatedAmount} loading={false} loadingFailed={false} />,
      isPreviewCell: true,
    },
    {
      Header: 'justStatus',
      Cell: ({
        row: {
          original: { status },
        },
      }) => <StatusCell statusCode={status} />,
      isPreviewCell: true,
    },
    {
      Header: 'clientAccountRecipient',
      Cell: ({
        row: {
          original: { withdrawAccount },
        },
      }) => <p className="recipient-account">{withdrawAccount || '-'}</p>,
    },
    {
      Header: 'justDate',
      Cell: ({
        row: {
          original: { date },
        },
      }) => <DateCell value={date} hideTime />,
    },
  ];
  /* eslint-enable */

  return (
    <div className="PartnerAccountInfoTable">
      <PaginationTable
        data={data}
        loading={loading}
        columns={columns}
        getList={getList}
        location={location}
        history={history}
        params={params}
      />
    </div>
  );
};

PartnerAccountInfoTable.propTypes = {
  data: PropTypes.object.isRequired,
  getList: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
};

export default PartnerAccountInfoTable;
